export default __webpack_public_path__ + "static/media/logo-md-1024w.617d8fd6.png";